import { TextSelection } from 'prosemirror-state';
import { canJoin, findWrapping } from 'prosemirror-transform';
import { getShortcutAttrs, TextShortcut } from './shortcut-plugin';
var textblockTypeTextShortcut = function (regexp, name, config) {
    return new TextShortcut(name, regexp, function (view, state, match, start, end) {
        var tr = state.tr;
        var $start = tr.doc.resolve(start);
        var attrs = getShortcutAttrs(config.handler, view, match, start, end);
        if (!attrs)
            return null;
        var nodeType = state.schema.nodes[name];
        if (!nodeType || !$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) {
            return null;
        }
        // like header
        if (nodeType.isTextblock) {
            return tr.setBlockType(start, undefined, nodeType, attrs).delete(start, end);
        }
        var subNodeType = nodeType.contentMatch.defaultType;
        // like hr
        if (!subNodeType) {
            return tr.replaceRangeWith($start.before(), $start.after(), nodeType.create(attrs));
        }
        else if (subNodeType !== $start.node().type) {
            // like list, blockquote
            tr.setBlockType($start.before(), $start.after(), subNodeType).setSelection(TextSelection.create(tr.doc, state.selection.from, state.selection.to));
        }
        tr.delete(start, end);
        var range = tr.selection.$from.blockRange();
        var wrapping = range && findWrapping(range, nodeType, attrs);
        if (!wrapping || !range)
            return null;
        tr.wrap(range, wrapping);
        var before = state.tr.doc.resolve(start - 1).nodeBefore;
        if (before && before.type === nodeType && canJoin(tr.doc, start - 1)) {
            tr.join(start - 1);
        }
        return tr;
    }, config);
};
export { textblockTypeTextShortcut };
//# sourceMappingURL=text-block-shortcut.js.map